
import { Button } from "@/components/ui/button";

interface EmptyResumesProps {
  onCreateTest: () => void;
  onLogin?: () => void;
  isAuthenticated: boolean;
}

const EmptyResumes = ({ onCreateTest, onLogin, isAuthenticated }: EmptyResumesProps) => {
  if (!isAuthenticated) {
    return (
      <div className="text-center text-gray-500 p-8 border rounded-md bg-gray-50">
        <p className="mb-4">You need to be logged in to view and create resumes.</p>
        <Button onClick={onLogin}>
          Log In
        </Button>
      </div>
    );
  }

  return (
    <div className="text-center text-gray-500 p-8 border rounded-md bg-gray-50">
      <p className="mb-4">No saved resumes. Click "New Resume" or "Create Test Resume" to get started.</p>
      <Button onClick={onCreateTest}>
        Create Test Resume
      </Button>
    </div>
  );
};

export default EmptyResumes;
